import { render, staticRenderFns } from "./GalleryViewComponent.vue?vue&type=template&id=44929c6f&"
import script from "./GalleryViewComponent.vue?vue&type=script&lang=js&"
export * from "./GalleryViewComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports